import { useCallback, useState } from 'react';

import { useRouteWorkspace } from '../contexts/RouteWorkspaceContext';
import { apiDelete } from '../lib/api_v2';
import { logError } from '../lib/logger';

const useLeaveWorkspace = () => {
  const { workspaceId } = useRouteWorkspace();
  const [isLeaving, setIsLeaving] = useState(false);

  const leave = useCallback(async () => {
    if (!workspaceId || isLeaving) return;

    setIsLeaving(true);
    try {
      const response = await apiDelete(`/workspaces/${workspaceId}/leave`);
      const data = await response.json();

      if (data.ok) {
        window.dispatchEvent(new CustomEvent('output:kill-workspace', { detail: { workspaceId } }));
      } else {
        alert('Could not leave space, please try again.');
        logError('useLeaveWorkspace', 'Failed to leave workspace', data.errors);
      }
    } catch (error) {
      alert('Could not leave space, please try again.');
      logError('useLeaveWorkspace', 'Failed to leave workspace', error);
    } finally {
      setIsLeaving(false);
    }
  }, [isLeaving, workspaceId]);

  return { leave, isLeaving };
};

export default useLeaveWorkspace;
